import React, { useState } from 'react';
import { Button, Modal, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { FilterOutlined } from '@ant-design/icons';
import AdvancedFilter from './AdvancedFilter';

const AdvancedFilterV2 = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <Popover placement="bottom" content={t('advancedSearch.title')}>
        <Button type="link">
          <FilterOutlined
            style={{
              fontSize: 25,
              marginLeft: 5
            }}
            onClick={() => {
              setVisible(true);
            }}
          />
        </Button>
      </Popover>
      <Modal
        open={visible}
        width={800}
        title={t('advancedSearch.title')}
        cancelText={t('advancedSearch.cancel')}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
      >
        <AdvancedFilter setVisible={setVisible} resourceName="contracts" />
      </Modal>
    </div>
  );
};

export default AdvancedFilterV2;
